export default __webpack_public_path__ + "static/media/carousel-1.866c9cce.png";